import MDTypography from "components/MDTypography";

import { useProduct } from "context/ProductContext";
import { loadingColumn, loadingRow } from "components/LoadingItemsList";
import { useEffect } from "react";

export default function data() {
  const { products, setEditProduct, deleteProduct, loading } = useProduct();

  const handlePressEdit = (product) => {
    setEditProduct(product);
  };

  const handlePressDelete = (id) => {
    deleteProduct(id);
  };

  const productColumn = [
    { Header: "nome", accessor: "name", width: "45%", align: "left" },
    { Header: "descricao", accessor: "descricao", align: "center" },
    { Header: "ean", accessor: "ean", align: "center" },
    { Header: "Preço Varejo", accessor: "priceRetail", align: "center" },
    { Header: "Preço Atacado", accessor: "priceWholesale", align: "center" },
    { Header: "Qtd Estoque", accessor: "qtd_stock", align: "center" },
    { Header: "Validade", accessor: "validity", align: "center" },
    { Header: "Peso", accessor: "weight", align: "center" },
    { Header: "Categoria", accessor: "category", align: "center" },
    { Header: "action", accessor: "action", align: "center" },
    { Header: "delete", accessor: "delete", align: "center" },
  ];

  const productRows = Object.values(products).map((product) => ({
    name: (
      <MDTypography display="block" variant="button" fontWeight="medium">
        {product.name}
      </MDTypography>
    ),
    descricao: (
      <MDTypography variant="button">
        {/* {product?.descricao?.length === 0 ? product.descricao : "NÃO CADASTRADO"} */}
        {product.descricao}
      </MDTypography>
    ),
    ean: <MDTypography variant="button">{product.ean}</MDTypography>,
    priceRetail: <MDTypography variant="button">{product.priceRetail}</MDTypography>,
    priceWholesale: <MDTypography variant="button">{product.priceWholesale}</MDTypography>,
    qtd_stock: <MDTypography variant="button">{product.qtd_stock}</MDTypography>,
    validity: <MDTypography variant="button">{product.validity}</MDTypography>,
    weight: <MDTypography variant="button">{product.weight}</MDTypography>,
    category: (
      <MDTypography variant="button">
        {product.category ? product.category.name : "Sem Categoria"}
      </MDTypography>
    ),
    action: (
      <MDTypography
        display="block"
        variant="button"
        fontWeight="medium"
        onClick={() => handlePressEdit(product)} // Passing the id to the handler
        style={{ cursor: "pointer", color: "blue" }}
      >
        Editar
      </MDTypography>
    ),
    delete: (
      <MDTypography
        display="block"
        variant="button"
        fontWeight="medium"
        onClick={() => handlePressDelete(product.id)} // Passing the id to the handler
        style={{ cursor: "pointer", color: "#eb4034" }}
      >
        Delete
      </MDTypography>
    ),
  }));

  return {
    columns: loading ? loadingColumn : productColumn,
    rows: loading ? loadingRow : productRows,
  };
}
